// extracted by mini-css-extract-plugin
export default {"text":"OurHouse_text__8l9Y0","container":"OurHouse_container__Sh-uR"};